import { Button } from '../../../shared/ui'
import { RANGE_OPTIONS, type RangeDays, type Scope } from './useOutreachDashboard'

interface Props {
  scope: Scope
  onScope: (s: Scope) => void
  canPickScope: boolean
  days: RangeDays
  onDays: (d: RangeDays) => void
  onRefresh: () => void
  loading: boolean
  timezone: string | null
}

export function DashboardHeader({
  scope,
  onScope,
  canPickScope,
  days,
  onDays,
  onRefresh,
  loading,
  timezone,
}: Props) {
  return (
    <div className="od-header">
      <h2 className="od-title">Outreach</h2>
      {timezone && <span className="od-tz">Business timezone: {timezone}</span>}
      <div className="od-controls">
        {canPickScope && (
          <div className="filter-tabs" role="group" aria-label="Scope">
            <button
              type="button"
              className={scope === 'business' ? 'filter-tab active' : 'filter-tab'}
              aria-pressed={scope === 'business'}
              onClick={() => onScope('business')}
            >
              This business
            </button>
            <button
              type="button"
              className={scope === 'all' ? 'filter-tab active' : 'filter-tab'}
              aria-pressed={scope === 'all'}
              onClick={() => onScope('all')}
            >
              All businesses
            </button>
          </div>
        )}
        <select
          className="filter-select"
          aria-label="Date range"
          value={days}
          onChange={(e) => onDays(Number(e.target.value) as RangeDays)}
        >
          {RANGE_OPTIONS.map((d) => (
            <option key={d} value={d}>
              Last {d} days
            </option>
          ))}
        </select>
        <Button variant="secondary" onClick={onRefresh} disabled={loading}>
          {loading ? 'Refreshing…' : 'Refresh'}
        </Button>
      </div>
    </div>
  )
}
